export const POTypes = [
    {"id":"Sheet Stock","name":"Stock"},
    {"id":"Roll Stock","name":"Roll Stock"},
    {"id":"Envelope","name":"Envelopes"},
    {"id":"Outside Services","name":"Outside Services"},
    {"id":"Bindery","name":"Bindery"},
    {"id":"Custodial","name":"Custodial"},
    {"id":"Inks","name":"Inks"},
    {"id":"Prepress","name":"Prepress"},
    {"id":"Press","name":"Press"},
    {"id":"Shipping","name":"Shipping"},
    {"id":"Maintenance","name":"Maintenance"},
    {"id":"Boxes","name":"Boxes"},
    {"id":"MPS","name":"MPS"},
    
];



export const PLSOrderbylist = [
    {"id":4,"name":"Sheets / M","itemtype":["paper"]},
    {"id":4,"name":"Sheets / CWT","itemtype":["paper"]},
    {"id":4,"name":"Roll LBS","itemtype":["roll paper"]},
    {"id":3,"name":"Each","itemtype":["cust"]},
    {"id":4,"name":"Sheets","itemtype":["cust"]},
    {"id":5,"name":"LBS","itemtype":["cust"]},
    {"id":5,"name":"Lot","itemtype":["cust"]},
    {"id":6,"name":"Case","itemtype":["cust","paper"]},
    {"id":6,"name":"Pallet(s)","itemtype":["cust"]},
    {"id":6,"name":"Skid(s)","itemtype":["paper","cust"]},
    {"id":8,"name":"Box","itemtype":["paper","cust"]},
];

export const PLStypelist = [
    {"id":1,"name":"CWT"},
    {"id":2,"name":"Per M"},
    {"id":3,"name":"Each"},
    {"id":4,"name":"Roll LBS"},
    {"id":5,"name":"LBS"},
    {"id":6,"name":"Case"},
    {"id":8,"name":"Box"},
];

export const CFPtypelist = [
    {"id":1,"name":"Each"},
    {"id":2,"name":"Foot"},
    {"id":3,"name":"Roll"},
    {"id":4,"name":"Case"},
    {"id":5,"name":"Square Foot"},
    {"id":6,"name":"Yard"},
];

export const addinventorylist = [
    {"id":0,"name":""},
    {"id":1,"name":"Add from PO"},
    {"id":2,"name":"Add left over from job"},
    {"id":3,"name":"Add from customer stock"}, 
    {"id":4,"name":"Physical Count Adjustment"}, 
];
export const removeinventorylist = [
    {"id":2,"name":"Remove for job"},
    {"id":3,"name":"Remove for customer"}, 
    {"id":3,"name":"Remove as bad stock"}, 
    {"id":4,"name":"Physical Count Adjustment"}, 
];
export const adjustinventorylist = [
    {"id":2,"name":"Adjust wrong Quantity"},
    {"id":3,"name":"Adjust End of Month Totals"}, 
    {"id":3,"name":"Other"}, 

]

export const closeitem = [
    {"id":0,"name":"Open"},
    {"id":1,"name":"Closed"}, 

]


export const locationareas = [
    {"id":10,"name":"Select Area"},
    {"id":0,"name":"Paper Areas"},
    {"id":0,"name":"Digital"},
    {"id":0,"name":"Colormax"},
    {"id":0,"name":"Web Rolls"},
    {"id":0,"name":"Floor"},
    {"id":0,"name":"Fidelity"},
]

export const presses = [
    {"id":0,"name":"",itemid:0},
    {"id":9,"name":"Colormax",itemid:0},
    {"id":4,"name":"GL440",itemid:0},
    {"id":3,"name":"GL540",itemid:0},
    {"id":5,"name":"M110 - Folding",itemid:0},
    {"id":6,"name":"M110 - Sheeter",itemid:0},
    {"id":7,"name":"Ricoh B&W",itemid:0},
    {"id":8,"name":"Ricoh Color",itemid:0},
    {"id":10,"name":"Ricoh Oversized",itemid:0},
]

export const methods = [
    {"id":1,"name":"Sheetwise",itemid:0},
    {"id":2,"name":"Work & Turn",itemid:0},
    {"id":3,"name":"One-Sided",itemid:0},
    {"id":4,"name":"Perfect",itemid:0},
    {"id":5,"name":"Work & Tumble",itemid:0},
  
]

export const pullcutlist = [
    {"id":0,"name":"",itemid:0},
    {"id":1,"name":"Robert H",itemid:0},
    {"id":2,"name":"Pam B",itemid:0},
    {"id":5,"name":"Duane H",itemid:0},
    {"id":3,"name":"Kevin C",itemid:0},
    {"id":4,"name":"Laura N",itemid:0},
   
  
]

export const foldinglist = [
    {"id":0,"name":"",itemid:0},
    {"id":1,"name":"Robert H",itemid:0},
    {"id":2,"name":"Pam B",itemid:0},
    {"id":5,"name":"Duane H",itemid:0},
    {"id":3,"name":"Kevin C",itemid:0},
    {"id":4,"name":"Laura N",itemid:0},
   
  
]


export const inks = [
    {
        "_id": "63dd705d8385927688f883d1",
        "stockid": 7,
        "name": "M110 Process Black",
        "type": "process",
        "color": "black",
        "vendor": "6384b93c8841c84328f6e32d",
        "price": 3.75,
        "specific": 425000,
        "press": "1",
        "__v": 0
    },
    {
        "_id": "63dd705d8385927688f883d4",
        "stockid": 10,
        "name": "M110 Process Yellow",
        "type": "process",
        "color": "yellow",
        "vendor": "6384b93c8841c84328f6e32d",
        "price": 3.75,
        "specific": 425000,
        "press": "1",
        "__v": 0
    },
    {
        "_id": "63dd705d8385927688f883d8",
        "stockid": 14,
        "name": "GL40 Process Magenta",
        "type": "process",
        "color": "magenta",
        "vendor": "6384b93c8841c84328f6e32d",
        "price": 17.25,
        "specific": 425000,
        "press": "2",
        "__v": 0
    },
    {
        "_id": "63dd705d8385927688f883d6",
        "stockid": 12,
        "name": "GL40 Process Black",
        "type": "process",
        "color": "black",
        "vendor": "6384b93c8841c84328f6e32d",
        "price": 17.25,
        "specific": 425000,
        "press": "2",
        "__v": 0
    },
    {
        "_id": "63dd705d8385927688f883d2",
        "stockid": 8,
        "name": "M110 Process Cyan",
        "type": "process",
        "color": "cyan",
        "vendor": "6384b93c8841c84328f6e32d",
        "price": 3.75,
        "specific": 352500,
        "press": "1",
        "__v": 0,
        "defaultpriceunit": "LBS",
        "defaultorderby": "LBS"
    },
    {
        "_id": "63dd705d8385927688f883d0",
        "stockid": 6,
        "name": "AQ",
        "type": "aq",
        "color": "All",
        "vendor": "6384b93c8841c84328f6e32d",
        "price": 1.5,
        "specific": 200000,
        "press": "2",
        "__v": 0
    },
    {
        "_id": "63dd705d8385927688f883d9",
        "stockid": 15,
        "name": "GL40 Process Yellow",
        "type": "process",
        "color": "yellow",
        "vendor": "6384b93c8841c84328f6e32d",
        "price": 17.25,
        "specific": 425000,
        "press": "2",
        "__v": 0
    },
    {
        "_id": "63dd705d8385927688f883d5",
        "stockid": 11,
        "name": "M110 PMS",
        "type": "PMS",
        "color": "All",
        "vendor": "6384b93c8841c84328f6e32d",
        "price": 20,
        "specific": 400000,
        "press": "1",
        "__v": 0
    },
    {
        "_id": "63dd705d8385927688f883da",
        "stockid": 17,
        "name": "GL40 AQ",
        "type": "aq",
        "color": "All",
        "vendor": "6384b93c8841c84328f6e32d",
        "price": 3,
        "specific": 200000,
        "press": "2",
        "__v": 0
    },
    {
        "_id": "63dd705d8385927688f883d3",
        "stockid": 9,
        "name": "M110 Process Magenta",
        "type": "process",
        "color": "magenta",
        "vendor": "6384b93c8841c84328f6e32d",
        "price": 3.75,
        "specific": 425000,
        "press": "1",
        "__v": 0
    },
    {
        "_id": "63dd705d8385927688f883db",
        "stockid": 16,
        "name": "GL40 Process PMS",
        "type": "PMS",
        "color": "All",
        "vendor": "6384b93c8841c84328f6e32d",
        "price": 38.25,
        "specific": 400000,
        "press": "2",
        "__v": 0
    },
    {
        "_id": "63dd705d8385927688f883d7",
        "stockid": 13,
        "name": "GL40 Process Cyan",
        "type": "process",
        "color": "cyan",
        "vendor": "6384b93c8841c84328f6e32d",
        "price": 17.25,
        "specific": 352500,
        "press": "2",
        "__v": 0
    }
]